import React from "react";
import Icon from "atoms/Icon";
import { ReadyState } from "react-use-websocket";
import SettingsApplicationsIcon from "@mui/icons-material/SettingsApplications";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import crm from "assets/productlogo/crm.svg";
import tymeplus from "assets/productlogo/tymeplus.svg";
import tractask from "assets/productlogo/tractask.svg";
import myaccount from "assets/productlogo/myaccount.svg";
import timemoment from "moment-timezone";
//import timemoment from "moment-timezone";

import moment from "moment-timezone";

// Get a list of all time zones
export const TIMEZONELISTS = timemoment.tz.names();

export const TIMEZONELIST = TIMEZONELISTS.filter(
  (timezone) => !moment.tz(timezone).isDST()
);

// export const getDaylightTimeZones = () => {
//   return TIMEZONELIST.filter(timezone => moment.tz(timezone).isDST());
// };

const ORIGIN = window.location.origin;

// const LIVE_SOCKET = `wss://k1552lx101.execute-api.ap-southeast-4.amazonaws.com/prod/`;
// const TEST_SOCKET = `wss://wshiy9ugml.execute-api.ap-south-1.amazonaws.com/Prod/`;
// const DEV_SOCKET = `wss://wshiy9ugml.execute-api.ap-south-1.amazonaws.com/Prod/`;
export const WEB_SOCKET = `wss://seazby3hvd.execute-api.ap-southeast-3.amazonaws.com/prod`;
export const SERVICE_URL = `https://av1zm2foof.execute-api.ap-southeast-3.amazonaws.com/Prod/`;
export const AI_BASE_URL = `https://mvff9fjrsc.execute-api.ap-south-1.amazonaws.com/dev/`;
export const PAYMENT_URL = `https://oln2lkja7e.execute-api.ap-south-1.amazonaws.com/prod/`;
export const CLIENT_FEEDBACK_URL = `https://nzthh0zab8.execute-api.ap-south-1.amazonaws.com/Prod/`;

// export const SOCKET_URL =
//   ORIGIN.indexOf("localhost") > -1
//     ? TEST_SOCKET
//     : ORIGIN.indexOf("test") > -1
//       ? TEST_SOCKET
//       : LIVE_SOCKET;

export const publicStripeKey =
  "pk_test_51OFBIjF2reQ5Y8ZnwHYNbjLrmvPRdeaBO07aAno1YRwjI8npiqboLStodFFCMB0BP6Ain5kfsmHwoAG8yoUtQiDl00l99byquD";

export const Products = [
  {
    name: "Tymeplus",
    url: "",
    logo: tymeplus,
    access: true,
  },
  {
    name: "TracTask",
    url: `https://www.tractask.waila.co/?token=${window.localStorage.getItem(
      "token"
    )}`,
    logo: tractask,
    access: true,
  },
  {
    name: "Marketing Tool",
    url: `https://www.crm.waila.co/?token=${window.localStorage.getItem(
      "token"
    )}`,
    logo: crm,
    access: true,
  },
  {
    name: "My Account",
    url: `https://www.myaccount.waila.co/?token=${window.localStorage.getItem(
      "token"
    )}`,
    logo: myaccount,
    access: true,
  },
];

export const NON_EMPTY_REGEX = /^(?!\s*$).+/;

export const EMAIL_REGEX = /^[a-zA-Z0-9.%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const NON_EMPTY_SINGLE_NUMBER = /\b[0-9]\b/;

export const NON_EMPTY_NUMBER = /^\d+$/;

export const NON_CHARACTER = /^[0-9\.\-\+]+$/;

//Validate symbol except space
export const VALIDATE_SYMBOL = /^[^<>*|/\\~#{}()[\],$^%&+=_@'?.!"]+$/g;

export const VALIDATE_CHARACTER = /^[A-Za-z\s_-]+$/;

export const PUNCH_ACTIONS = {
  PUNCH_IN: 1,
  PUNCH_OUT: 2,
  BREAK_START: 3,
  BREAK_END: 4,
};

export const InitalSteps = {
  title: "",
  steps: [{ 0: "New" }],
};

export const STATUS = {
  SUCCESS: "SUCCESS",
  FAIL: "FAIL",
  ERROR: "ERROR",
  RECORD_NOT_FOUND: "RECORD_NOT_FOUND",
};

const dashboardMenu = {
  key: "dashboard",
  icon: <Icon name="dashboard" />,
  path: "dashboard",
  title: "Dashboard",
};

const adminDashboardMenu = {
  key: "dashboard",
  icon: <Icon name="dashboard" />,
  title: "Dashboard",
  subMenu: [
    {
      key: "dashboard",
      path: "dashboard",
      title: "Dashboard",
      icon: <Icon name="subdashboard" />,
    },
    {
      key: "trends",
      path: "trends",
      title: "Trends",
      icon: <Icon name="trends" />,
    },
    {
      key: "demographics",
      path: "demographics",
      title: "Demographics",
      icon: <Icon name="demographics" />,
    },
    {
      key: "productivity",
      path: "productivity",
      title: "Productivity",
      icon: <SettingsApplicationsIcon style={{ fontSize: "20px" }} />,
    },
  ],
};

const approvalMenu = {
  key: "approvals",
  icon: <Icon name="approvals" />,
  path: "approvals",
  title: "Approvals",
};

const calendarMenu = {
  key: "calendar",
  icon: <Icon name="calendar" />,
  path: "calendar",
  title: "Calendar",
};

const locationMenu = {
  key: "location",
  icon: <Icon name="location" />,
  path: "location",
  title: "Location",
};

const myCalendarMenu = {
  key: "calendar",
  icon: <Icon name="calendar" />,
  path: "calendar",
  title: "My Calendar",
};

const teamMenu = {
  key: "team",
  icon: <Icon name="team" />,
  path: "team",
  title: "Teams",
};

const myTeamMenu = {
  key: "team",
  icon: <Icon name="team" />,
  path: "team",
  title: "My Team",
};

const myDocumentMenu = {
  key: "mydocuments",
  icon: <Icon name="document" />,
  path: "mydocuments",
  title: "My Documents",
};

const taskMenu = {
  key: "task",
  icon: <Icon name="task" />,
  path: "task",
  title: "Task",
};

const myTaskMenu = {
  key: "mytask",
  icon: <Icon name="task" />,
  path: "mytask",
  title: "My Task",
};

const myLeaveReport = {
  key: "leavereport",
  icon: <Icon name="leave" />,
  path: "myleavereport",
  title: "My Leave History",
};

const reportMenu = {
  key: "reports",
  icon: <Icon name="report" />,
  title: "Reports",
  subMenu: [
    {
      key: "attendance-report",
      title: "Attendance",
      icon: <Icon name="attendance" />,
      subMenu: [
        {
          key: "attendance-report-daily",
          path: "attendance-report",
          title: "Daily",
          icon: <DoneAllIcon style={{ fontSize: "20px" }} />,
        },
        {
          key: "attendance-report-monthly",
          path: "attendance-report-monthly",
          title: "Monthly",
          icon: <CalendarMonthIcon style={{ fontSize: "20px" }} />,
        },
      ],
    },
    {
      key: "leave-report",
      path: "leave-report",
      title: "Leave",
      icon: <Icon name="leave" />,
    },
    {
      key: "break-report",
      path: "break-report",
      title: "Break",
      icon: <Icon name="break" />,
    },
    {
      key: "overtime-report",
      path: "overtime-report",
      title: "Overtime",
      icon: <Icon name="overtime" />,
    },
  ],
};

const ExceptionReport = {
  key: "Exception Reports",
  icon: <Icon name="exceptionreport" />,
  title: "Exception Reports",
  subMenu: [
    {
      key: "Late check-in",
      path: "Late-check-in",
      title: "Late check-in",
      icon: <Icon name="latecheckin" />,
    },
    {
      key: "Early check-out",
      path: "Early-check-out",
      title: "Early check-out",
      icon: <Icon name="earlycheckout" />,
    },
    {
      key: "Absent report",
      path: "Absent-report",
      title: "Absent report",
      icon: <Icon name="absentreport" />,
    },
  ],
};

const employeeMenu = {
  key: "employee",
  icon: <Icon name="employee" />,
  path: "employee",
  title: "Employee",
};

const departmentMenu = {
  key: "department",
  icon: <Icon name="department" />,
  path: "department",
  title: "Department",
};

const roleMenu = {
  key: "role",
  icon: <Icon name="role" />,
  path: "roles",
  title: "Role",
};
const shiftMenu = {
  key: "shift",
  icon: <Icon name="shift" />,
  path: "shift",
  title: "Shift",
};

export const HR_MENU = [
  dashboardMenu,
  approvalMenu,
  calendarMenu,
  teamMenu,
  reportMenu,
  ExceptionReport,
];

export const CEO_MENU = [
  dashboardMenu,
  approvalMenu,
  calendarMenu,
  teamMenu,
  reportMenu,
  ExceptionReport,
];

export const HOD_MENU = [
  dashboardMenu,
  approvalMenu,
  calendarMenu,
  teamMenu,
  taskMenu,
  reportMenu,
  ExceptionReport,
];

export const STAFF_MENU = [
  dashboardMenu,
  myCalendarMenu,
  myTeamMenu,
  myDocumentMenu,
  myTaskMenu,
  myLeaveReport,
];

export const ADMIN = [
  adminDashboardMenu,
  departmentMenu,
  locationMenu,
  employeeMenu,
  roleMenu,
  shiftMenu,
];

export const MENU = {
  1: HR_MENU,
  2: HOD_MENU,
  3: HOD_MENU,
  4: STAFF_MENU,
  5: ADMIN,
  6: CEO_MENU,
};

export const STATUS_CODE = {
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
  INVALID_PAYLOAD: "INVALID_PAYLOAD",
  AUTHENTICATION_FAILED: "AUTHENTICATION_FAILED",
  AUTHENTICATION_SUCCESSFUL: "AUTHENTICATION_SUCCESSFUL",
  USER_DISABLED: "USER_DISABLED",
  VALID_SESSION: "VALID_SESSION",
  SAME_PASSWORD: "SAME_PASSWORD",
  INVALID_CODE: "INVALID_CODE",
  RECORD_NOT_FOUND: "RECORD_NOT_FOUND",
  INVALID_SESSION: "INVALID_SESSION",
  PASSWORD_UPDATED: "PASSWORD_UPDATED",
  RECORD_EXIST: "RECORD_EXIST",
  OUTSIDE_ALLOWED_PROXIMITY: "OUTSIDE_ALLOWED_PROXIMITY",
  PUNCH_IN_SUCCESSFUL: "PUNCH_IN_SUCCESSFUL",
  PUNCH_OUT_SUCCESSFUL: "PUNCH_OUT_SUCCESSFUL",
  BREAK_STARTED: "BREAK_STARTED",
  BREAK_ENDED: "BREAK_ENDED",
  SOMETHING_WENT_WRONG: "SOMETHING_WENT_WRONG",
  TASK_SAVED: "TASK_SAVED",
  TASK_DELETED: "TASK_DELETED",
  LEAVE_EXCEED: "LEAVE_EXCEED",
  ANNUAL_LEAVE_AVAILABLE: "ANNUAL_LEAVE_AVAILABLE",
  SICK_LEAVE_AVAILABLE: "SICK_LEAVE_AVAILABLE",
  REASON: "SEND_REASON",
};

export const LEAVE_INFO = {
  AVAILABLE: "Available",
  CONSUMED: "Consumed",
};

export const USER_REPORT = {
  ONTIME: "OnTime",
  LATE: "Late",
  LEAVE: "Leave",
  EARLYEXIT: "Early Exit",
  ABSENT: "Absent",
};

export const LEAVE_ICON = {
  7: "calendar2",
  1: "medical_box",
  2: "medical_box",
  3: "medical_box",
  5: "pregnant_woman",
  6: "baby_carrier",
};

export const EXPENSE_STATUS = [
  { value: "All", label: "All" },
  { value: "Waiting", label: "Waiting" },
  { value: "Approved", label: "Approved" },
  { value: "Declined", label: "Declined" },
];

export const TYPE_OF_EXPENSE = [
  { value: "travel", label: "Travel" },
  { value: "others", label: "Others" },
];

const Currencies = [
  "US Dollar",
  "Euro",
  "Japanese Yen",
  "British Pound",
  "Australian Dollar",
  "Canadian Dollar",
  "Swiss Franc",
  "Chinese Yuan",
  "Indian Rupee",
  "Brazilian Real",
  "Russian Ruble",
  "South African Rand",
  "Mexican Peso",
  "New Zealand Dollar",
  "Singapore Dollar",
  "Hong Kong Dollar",
  "Swedish Krona",
  "Norwegian Krone",
  "South Korean Won",
  "Turkish Lira",
  // Add more currencies as needed
];

export const TYPE_OF_CURRENCIES = Currencies.map((currency) => ({
  value: currency,
  label: currency,
}));

export const REPORT_DURATION_TYPES = [
  { value: 2, label: "Monthly Report" },
  { value: 1, label: "Custom Date" },
];
export const REPORT_DURATION_TYPES1 = [{ value: 2, label: "Monthly Report" }];

export const APPROVAL_FILTER_TYPES = [
  { value: 4, label: "All" },
  { value: 1, label: "Custom Date" },
  { value: 2, label: "Monthly" },
];

export const CHECKIN_REPORT_FILTER_TYPES = [
  { value: 1, label: "Custom Date" },
  { value: 2, label: "Monthly" },
];
export const MONTH_LIST = [
  { index: 1, value: "January", label: "January" },
  { index: 2, value: "February", label: "February" },
  { index: 3, value: "March", label: "March" },
  { index: 4, value: "April", label: "April" },
  { index: 5, value: "May", label: "May" },
  { index: 6, value: "June", label: "June" },
  { index: 7, value: "July", label: "July" },
  { index: 8, value: "August", label: "August" },
  { index: 9, value: "September", label: "September" },
  { index: 10, value: "October", label: "October" },
  { index: 11, value: "November", label: "November" },
  { index: 12, value: "December", label: "December" },
];

export const WEB_SOCKET_CONNECTION_STATUS = {
  [ReadyState.CONNECTING]: "Connecting",
  [ReadyState.OPEN]: "Open",
  [ReadyState.CLOSING]: "Closing",
  [ReadyState.CLOSED]: "Closed",
  [ReadyState.UNINSTANTIATED]: "Uninstantiated",
};

export const countryList = [
  "Afghanistan",
  "Aland Islands",
  "Albania",
  "Algeria",
  "American Samoa",
  "Andorra",
  "Angola",
  "Anguilla",
  "Antarctica",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Aruba",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bermuda",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Bouvet Island",
  "Brazil",
  "British Indian Ocean Territory",
  "Brunei Darussalam",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Cape Verde",
  "Cayman Islands",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Christmas Island",
  "Cocos (Keeling) Islands",
  "Colombia",
  "Comoros",
  "Congo",
  "Congo, The Democratic Republic of The",
  "Cook Islands",
  "Costa Rica",
  "Cote D'ivoire",
  "Croatia",
  "Cuba",
  "Curaçao",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Ethiopia",
  "Falkland Islands (Malvinas)",
  "Faroe Islands",
  "Fiji",
  "Finland",
  "France",
  "French Guiana",
  "French Polynesia",
  "French Southern Territories",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Gibraltar",
  "Greece",
  "Greenland",
  "Grenada",
  "Guadeloupe",
  "Guam",
  "Guatemala",
  "Guernsey",
  "Guinea",
  "Guinea-bissau",
  "Guyana",
  "Haiti",
  "Heard Island and Mcdonald Islands",
  "Holy See (Vatican City State)",
  "Honduras",
  "Hong Kong",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran, Islamic Republic of",
  "Iraq",
  "Ireland",
  "Isle of Man",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jersey",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Korea, Democratic People's Republic of",
  "Korea, Republic of",
  "Kuwait",
  "Kyrgyzstan",
  "Lao People's Democratic Republic",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libyan Arab Jamahiriya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macao",
  "Macedonia, The Former Yugoslav Republic of",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Martinique",
  "Mauritania",
  "Mauritius",
  "Mayotte",
  "Mexico",
  "Micronesia, Federated States of",
  "Moldova, Republic of",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Montserrat",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "New Caledonia",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "Niue",
  "Norfolk Island",
  "Northern Mariana Islands",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestinian Territory, Occupied",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Pitcairn",
  "Poland",
  "Portugal",
  "Puerto Rico",
  "Qatar",
  "Reunion",
  "Romania",
  "Russia",
  "Rwanda",
  "Saint Helena",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Pierre and Miquelon",
  "Saint Vincent and The Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Georgia and The South Sandwich Islands",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Svalbard and Jan Mayen",
  "Eswatini",
  "Sweden",
  "Switzerland",
  "Syrian Arab Republic",
  "Taiwan (ROC)",
  "Tajikistan",
  "Tanzania, United Republic of",
  "Thailand",
  "Timor-leste",
  "Togo",
  "Tokelau",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Turks and Caicos Islands",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "United States Minor Outlying Islands",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Venezuela",
  "Vietnam",
  "Virgin Islands, British",
  "Virgin Islands, U.S.",
  "Wallis and Futuna",
  "Western Sahara",
  "Yemen",
  "Zambia",
  "Zimbabwe",
];

export const AwardList = [
  "Select",
  "Accounting and Auditing Board of Ethiopia",
  "Association of Chartered Certified Accountants",
  "Cisco Certified Network Associate",
  "Certified Ethical Hacker",
  "Chartered Financial Analyst",
  "Chartered Financial Analyst Institute",
  "Certified Human Resource Professional",
  "Certified Investment & Financial Analyst",
  "Chartered Institute of Marketing",
  "Chartered Institute of Procurement & Supply",
  "Certified Information Systems Auditor",
  "Computer Industry and Services Association of Kenya",
  "Certified Information Systems Manager",
  "Chartered Marketing Management Professional",
  "Certified Public Accountant",
  "Certified Public Secretary",
  "Certified Procurement and Supply Professional – Kenya",
  "Institute of Certified Investment & Financial Analysts",
  "Institute of Certified Public Accountants of Kenya",
  "Institute of Certified Public Accountants of Rwanda",
  "Institute of Certified Public Accountants of Uganda",
  "Institute of Certified Secretaries of Kenya",
  "Institute of Directors",
  "Institute of Human Resource Management",
  "Institute of Internal Auditors",
  "Information Systems Audit and Control Association",
  "Microsoft Certified AI Engineer",
  "Microsoft Certified Data Engineer",
  "Microsoft Certified DevOps Engineer",
  "Microsoft Certified Data Scientist",
  "Microsoft Certified Functional Consultant",
  "Microsoft Certified Systems Administrator",
  "Microsoft Certified Solutions Architect",
  "Microsoft Certified Systems Developer",
  "Microsoft Certified Security Engineer",
  "Marketing Society of Kenya",
  "National Board of Accountants and Auditors – Tanzania",
  "Project Management Institute",
  "Project Management Professional",
];

export const CountryData = [
  {
    name: "Australia",
    dial_code: "+61",
    code: "AU",
    phone_length: 9,
  },
  {
    name: "India",
    dial_code: "+91",
    code: "IN",
    phone_length: 10,
  },
  {
    name: "Afghanistan",
    dial_code: "+93",
    code: "AF",
    phone_length: 9,
  },
  {
    name: "Aland Islands",
    dial_code: "+358",
    code: "AX",
    phone_length: 9,
  },
  {
    name: "Albania",
    dial_code: "+355",
    code: "AL",
    phone_length: 9,
  },
  {
    name: "Algeria",
    dial_code: "+213",
    code: "DZ",
    phone_length: 9,
  },
  {
    name: "American Samoa",
    dial_code: "+1684",
    code: "AS",
    phone_length: 7,
  },
  {
    name: "Andorra",
    dial_code: "+376",
    code: "AD",
    phone_length: 6,
  },
  {
    name: "Angola",
    dial_code: "+244",
    code: "AO",
    phone_length: 9,
  },
  {
    name: "Anguilla",
    dial_code: "+1264",
    code: "AI",
    phone_length: 7,
  },
  {
    name: "Antarctica",
    dial_code: "+672",
    code: "AQ",
    phone_length: 7,
  },
  {
    name: "Antigua and Barbuda",
    dial_code: "+1268",
    code: "AG",
    phone_length: 7,
  },
  {
    name: "Argentina",
    dial_code: "+54",
    code: "AR",
    phone_length: 10,
  },
  {
    name: "Armenia",
    dial_code: "+374",
    code: "AM",
    phone_length: 8,
  },
  {
    name: "Aruba",
    dial_code: "+297",
    code: "AW",
    phone_length: 7,
  },
  {
    name: "Austria",
    dial_code: "+43",
    code: "AT",
    phone_length: 10,
  },
  {
    name: "Azerbaijan",
    dial_code: "+994",
    code: "AZ",
    phone_length: 9,
  },
  {
    name: "Bahamas",
    dial_code: "+1242",
    code: "BS",
    phone_length: 7,
  },
  {
    name: "Bahrain",
    dial_code: "+973",
    code: "BH",
    phone_length: 8,
  },
  {
    name: "Bangladesh",
    dial_code: "+880",
    code: "BD",
    phone_length: 10,
  },
  {
    name: "Barbados",
    dial_code: "+1246",
    code: "BB",
    phone_length: 7,
  },
  {
    name: "Belarus",
    dial_code: "+375",
    code: "BY",
    phone_length: 9,
  },
  {
    name: "Belgium",
    dial_code: "+32",
    code: "BE",
    phone_length: 9,
  },
  {
    name: "Belize",
    dial_code: "+501",
    code: "BZ",
    phone_length: 7,
  },
  {
    name: "Benin",
    dial_code: "+229",
    code: "BJ",
    phone_length: 9,
  },
  {
    name: "Bermuda",
    dial_code: "+1441",
    code: "BM",
    phone_length: 7,
  },
  {
    name: "Bhutan",
    dial_code: "+975",
    code: "BT",
    phone_length: 8,
  },
  {
    name: "Bolivia",
    dial_code: "+591",
    code: "BO",
    phone_length: 8,
  },
  {
    name: "Bosnia and Herzegovina",
    dial_code: "+387",
    code: "BA",
    phone_length: 8,
  },
  {
    name: "Botswana",
    dial_code: "+267",
    code: "BW",
    phone_length: 7,
  },
  {
    name: "Brazil",
    dial_code: "+55",
    code: "BR",
    phone_length: 10,
  },
  {
    name: "British Indian Ocean Territory",
    dial_code: "+246",
    code: "IO",
    phone_length: 7,
  },
  {
    name: "Brunei Darussalam",
    dial_code: "+673",
    code: "BN",
    phone_length: 7,
  },
  {
    name: "Bulgaria",
    dial_code: "+359",
    code: "BG",
    phone_length: 9,
  },
  {
    name: "Burkina Faso",
    dial_code: "+226",
    code: "BF",
    phone_length: 8,
  },
  {
    name: "Burundi",
    dial_code: "+257",
    code: "BI",
    phone_length: 8,
  },
  {
    name: "Cambodia",
    dial_code: "+855",
    code: "KH",
    phone_length: 9,
  },
  {
    name: "Cameroon",
    dial_code: "+237",
    code: "CM",
    phone_length: 9,
  },
  {
    name: "Canada",
    dial_code: "+1",
    code: "CA",
    phone_length: 10,
  },
  {
    name: "Cape Verde",
    dial_code: "+238",
    code: "CV",
    phone_length: 7,
  },
  {
    name: "Cayman Islands",
    dial_code: "+345",
    code: "KY",
    phone_length: 7,
  },
  {
    name: "Central African Republic",
    dial_code: "+236",
    code: "CF",
    phone_length: 9,
  },
  {
    name: "Chad",
    dial_code: "+235",
    code: "TD",
    phone_length: 9,
  },
  {
    name: "Chile",
    dial_code: "+56",
    code: "CL",
    phone_length: 9,
  },
  {
    name: "China",
    dial_code: "+86",
    code: "CN",
    phone_length: 11,
  },
  {
    name: "Christmas Island",
    dial_code: "+61",
    code: "CX",
    phone_length: 9,
  },
  {
    name: "Cocos (Keeling) Islands",
    dial_code: "+61",
    code: "CC",
    phone_length: 9,
  },
  {
    name: "Colombia",
    dial_code: "+57",
    code: "CO",
    phone_length: 10,
  },
  {
    name: "Comoros",
    dial_code: "+269",
    code: "KM",
    phone_length: 7,
  },
  {
    name: "Congo",
    dial_code: "+242",
    code: "CG",
    phone_length: 9,
  },
  {
    name: "Congo, The Democratic Republic of the",
    dial_code: "+243",
    code: "CD",
    phone_length: 9,
  },
  {
    name: "Cook Islands",
    dial_code: "+682",
    code: "CK",
    phone_length: 5,
  },
  {
    name: "Costa Rica",
    dial_code: "+506",
    code: "CR",
    phone_length: 8,
  },
  {
    name: "Cote d'Ivoire",
    dial_code: "+225",
    code: "CI",
    phone_length: 8,
  },
  {
    name: "Croatia",
    dial_code: "+385",
    code: "HR",
    phone_length: 9,
  },
  {
    name: "Cuba",
    dial_code: "+53",
    code: "CU",
    phone_length: 8,
  },
  {
    name: "Cyprus",
    dial_code: "+357",
    code: "CY",
    phone_length: 8,
  },
  {
    name: "Czech Republic",
    dial_code: "+420",
    code: "CZ",
    phone_length: 9,
  },
  {
    name: "Denmark",
    dial_code: "+45",
    code: "DK",
    phone_length: 8,
  },
  {
    name: "Djibouti",
    dial_code: "+253",
    code: "DJ",
    phone_length: 8,
  },
  {
    name: "Dominica",
    dial_code: "+1767",
    code: "DM",
    phone_length: 7,
  },
  {
    name: "Dominican Republic",
    dial_code: "+1849",
    code: "DO",
    phone_length: 10,
  },
  {
    name: "Ecuador",
    dial_code: "+593",
    code: "EC",
    phone_length: 9,
  },
  {
    name: "Egypt",
    dial_code: "+20",
    code: "EG",
    phone_length: 10,
  },
  {
    name: "El Salvador",
    dial_code: "+503",
    code: "SV",
    phone_length: 8,
  },
  {
    name: "Equatorial Guinea",
    dial_code: "+240",
    code: "GQ",
    phone_length: 9,
  },
  {
    name: "Eritrea",
    dial_code: "+291",
    code: "ER",
    phone_length: 7,
  },
  {
    name: "Estonia",
    dial_code: "+372",
    code: "EE",
    phone_length: 7,
  },
  {
    name: "Ethiopia",
    dial_code: "+251",
    code: "ET",
    phone_length: 9,
  },
  {
    name: "Falkland Islands (Malvinas)",
    dial_code: "+500",
    code: "FK",
    phone_length: 5,
  },
  {
    name: "Faroe Islands",
    dial_code: "+298",
    code: "FO",
    phone_length: 6,
  },
  {
    name: "Fiji",
    dial_code: "+679",
    code: "FJ",
    phone_length: 7,
  },
  {
    name: "Finland",
    dial_code: "+358",
    code: "FI",
    phone_length: 9,
  },
  {
    name: "France",
    dial_code: "+33",
    code: "FR",
    phone_length: 9,
  },
  {
    name: "French Guiana",
    dial_code: "+594",
    code: "GF",
    phone_length: 9,
  },
  {
    name: "French Polynesia",
    dial_code: "+689",
    code: "PF",
    phone_length: 6,
  },
  {
    name: "Gabon",
    dial_code: "+241",
    code: "GA",
    phone_length: 9,
  },
  {
    name: "Gambia",
    dial_code: "+220",
    code: "GM",
    phone_length: 7,
  },
  {
    name: "Georgia",
    dial_code: "+995",
    code: "GE",
    phone_length: 9,
  },
  {
    name: "Germany",
    dial_code: "+49",
    code: "DE",
    phone_length: 10,
  },
  {
    name: "Ghana",
    dial_code: "+233",
    code: "GH",
    phone_length: 9,
  },
  {
    name: "Gibraltar",
    dial_code: "+350",
    code: "GI",
    phone_length: 8,
  },
  {
    name: "Greece",
    dial_code: "+30",
    code: "GR",
    phone_length: 10,
  },
  {
    name: "Greenland",
    dial_code: "+299",
    code: "GL",
    phone_length: 6,
  },
  {
    name: "Grenada",
    dial_code: "+1473",
    code: "GD",
    phone_length: 7,
  },
  {
    name: "Guadeloupe",
    dial_code: "+590",
    code: "GP",
    phone_length: 9,
  },
  {
    name: "Guam",
    dial_code: "+1671",
    code: "GU",
    phone_length: 7,
  },
  {
    name: "Guatemala",
    dial_code: "+502",
    code: "GT",
    phone_length: 8,
  },
  {
    name: "Guernsey",
    dial_code: "+44",
    code: "GG",
    phone_length: 10,
  },
  {
    name: "Guinea",
    dial_code: "+224",
    code: "GN",
    phone_length: 9,
  },
  {
    name: "Guinea-Bissau",
    dial_code: "+245",
    code: "GW",
    phone_length: 7,
  },
  {
    name: "Guyana",
    dial_code: "+592",
    code: "GY",
    phone_length: 7,
  },
  {
    name: "Haiti",
    dial_code: "+509",
    code: "HT",
    phone_length: 8,
  },
  {
    name: "Holy See (Vatican City State)",
    dial_code: "+379",
    code: "VA",
    phone_length: 10,
  },
  {
    name: "Honduras",
    dial_code: "+504",
    code: "HN",
    phone_length: 8,
  },
  {
    name: "Hong Kong",
    dial_code: "+852",
    code: "HK",
    phone_length: 8,
  },
  {
    name: "Hungary",
    dial_code: "+36",
    code: "HU",
    phone_length: 9,
  },
  {
    name: "Iceland",
    dial_code: "+354",
    code: "IS",
    phone_length: 7,
  },
  {
    name: "Indonesia",
    dial_code: "+62",
    code: "ID",
    phone_length: 10,
  },
  {
    name: "Iran, Islamic Republic of",
    dial_code: "+98",
    code: "IR",
    phone_length: 10,
  },
  {
    name: "Iraq",
    dial_code: "+964",
    code: "IQ",
    phone_length: 10,
  },
  {
    name: "Ireland",
    dial_code: "+353",
    code: "IE",
    phone_length: 9,
  },
  {
    name: "Isle of Man",
    dial_code: "+44",
    code: "IM",
    phone_length: 10,
  },
  {
    name: "Israel",
    dial_code: "+972",
    code: "IL",
    phone_length: 9,
  },
  {
    name: "Italy",
    dial_code: "+39",
    code: "IT",
    phone_length: 9,
  },
  {
    name: "Jamaica",
    dial_code: "+1876",
    code: "JM",
    phone_length: 7,
  },
  {
    name: "Japan",
    dial_code: "+81",
    code: "JP",
    phone_length: 10,
  },
  {
    name: "Jersey",
    dial_code: "+44",
    code: "JE",
    phone_length: 10,
  },
  {
    name: "Jordan",
    dial_code: "+962",
    code: "JO",
    phone_length: 9,
  },
  {
    name: "Kazakhstan",
    dial_code: "+7",
    code: "KZ",
    phone_length: 10,
  },
  {
    name: "Kenya",
    dial_code: "+254",
    code: "KE",
    phone_length: 9,
  },
  {
    name: "Kiribati",
    dial_code: "+686",
    code: "KI",
    phone_length: 8,
  },
  {
    name: "Korea, Democratic People's Republic of",
    dial_code: "+850",
    code: "KP",
    phone_length: 10,
  },
  {
    name: "Korea, Republic of",
    dial_code: "+82",
    code: "KR",
    phone_length: 10,
  },
  {
    name: "Kuwait",
    dial_code: "+965",
    code: "KW",
    phone_length: 8,
  },
  {
    name: "Kyrgyzstan",
    dial_code: "+996",
    code: "KG",
    phone_length: 9,
  },
  {
    name: "Lao People's Democratic Republic",
    dial_code: "+856",
    code: "LA",
    phone_length: 10,
  },
  {
    name: "Latvia",
    dial_code: "+371",
    code: "LV",
    phone_length: 8,
  },
  {
    name: "Lebanon",
    dial_code: "+961",
    code: "LB",
    phone_length: 8,
  },
  {
    name: "Lesotho",
    dial_code: "+266",
    code: "LS",
    phone_length: 8,
  },
  {
    name: "Liberia",
    dial_code: "+231",
    code: "LR",
    phone_length: 7,
  },
  {
    name: "Libyan Arab Jamahiriya",
    dial_code: "+218",
    code: "LY",
    phone_length: 9,
  },
  {
    name: "Liechtenstein",
    dial_code: "+423",
    code: "LI",
    phone_length: 7,
  },
  {
    name: "Lithuania",
    dial_code: "+370",
    code: "LT",
    phone_length: 8,
  },
  {
    name: "Luxembourg",
    dial_code: "+352",
    code: "LU",
    phone_length: 9,
  },
  {
    name: "Macao",
    dial_code: "+853",
    code: "MO",
    phone_length: 8,
  },
  {
    name: "Macedonia, The Former Yugoslav Republic of",
    dial_code: "+389",
    code: "MK",
    phone_length: 8,
  },
  {
    name: "Madagascar",
    dial_code: "+261",
    code: "MG",
    phone_length: 9,
  },
  {
    name: "Malawi",
    dial_code: "+265",
    code: "MW",
    phone_length: 7,
  },
  {
    name: "Malaysia",
    dial_code: "+60",
    code: "MY",
    phone_length: 9,
  },
  {
    name: "Maldives",
    dial_code: "+960",
    code: "MV",
    phone_length: 7,
  },
  {
    name: "Mali",
    dial_code: "+223",
    code: "ML",
    phone_length: 8,
  },
  {
    name: "Malta",
    dial_code: "+356",
    code: "MT",
    phone_length: 8,
  },
  {
    name: "Marshall Islands",
    dial_code: "+692",
    code: "MH",
    phone_length: 7,
  },
  {
    name: "Martinique",
    dial_code: "+596",
    code: "MQ",
    phone_length: 9,
  },
  {
    name: "Mauritania",
    dial_code: "+222",
    code: "MR",
    phone_length: 9,
  },
  {
    name: "Mauritius",
    dial_code: "+230",
    code: "MU",
    phone_length: 8,
  },
  {
    name: "Mayotte",
    dial_code: "+262",
    code: "YT",
    phone_length: 9,
  },
  {
    name: "Mexico",
    dial_code: "+52",
    code: "MX",
    phone_length: 10,
  },
  {
    name: "Micronesia, Federated States of",
    dial_code: "+691",
    code: "FM",
    phone_length: 7,
  },
  {
    name: "Moldova, Republic of",
    dial_code: "+373",
    code: "MD",
    phone_length: 8,
  },
  {
    name: "Monaco",
    dial_code: "+377",
    code: "MC",
    phone_length: 8,
  },
  {
    name: "Mongolia",
    dial_code: "+976",
    code: "MN",
    phone_length: 8,
  },
  {
    name: "Montenegro",
    dial_code: "+382",
    code: "ME",
    phone_length: 8,
  },
  {
    name: "Montserrat",
    dial_code: "+1664",
    code: "MS",
    phone_length: 7,
  },
  {
    name: "Morocco",
    dial_code: "+212",
    code: "MA",
    phone_length: 9,
  },
  {
    name: "Mozambique",
    dial_code: "+258",
    code: "MZ",
    phone_length: 9,
  },
  {
    name: "Myanmar",
    dial_code: "+95",
    code: "MM",
    phone_length: 9,
  },
  {
    name: "Namibia",
    dial_code: "+264",
    code: "NA",
    phone_length: 9,
  },
  {
    name: "Nauru",
    dial_code: "+674",
    code: "NR",
    phone_length: 8,
  },
  {
    name: "Nepal",
    dial_code: "+977",
    code: "NP",
    phone_length: 10,
  },
  {
    name: "Netherlands",
    dial_code: "+31",
    code: "NL",
    phone_length: 9,
  },
  {
    name: "Netherlands Antilles",
    dial_code: "+599",
    code: "AN",
    phone_length: 9,
  },
  {
    name: "New Caledonia",
    dial_code: "+687",
    code: "NC",
    phone_length: 6,
  },
  {
    name: "New Zealand",
    dial_code: "+64",
    code: "NZ",
    phone_length: 9,
  },
  {
    name: "Nicaragua",
    dial_code: "+505",
    code: "NI",
    phone_length: 8,
  },
  {
    name: "Niger",
    dial_code: "+227",
    code: "NE",
    phone_length: 8,
  },
  {
    name: "Nigeria",
    dial_code: "+234",
    code: "NG",
    phone_length: 9,
  },
  {
    name: "Niue",
    dial_code: "+683",
    code: "NU",
    phone_length: 4,
  },
  {
    name: "Norfolk Island",
    dial_code: "+672",
    code: "NF",
    phone_length: 6,
  },
  {
    name: "Northern Mariana Islands",
    dial_code: "+1670",
    code: "MP",
    phone_length: 7,
  },
  {
    name: "Norway",
    dial_code: "+47",
    code: "NO",
    phone_length: 8,
  },
  {
    name: "Oman",
    dial_code: "+968",
    code: "OM",
    phone_length: 8,
  },
  {
    name: "Pakistan",
    dial_code: "+92",
    code: "PK",
    phone_length: 10,
  },
  {
    name: "Palau",
    dial_code: "+680",
    code: "PW",
    phone_length: 7,
  },
  {
    name: "Palestinian Territory, Occupied",
    dial_code: "+970",
    code: "PS",
    phone_length: 9,
  },
  {
    name: "Panama",
    dial_code: "+507",
    code: "PA",
    phone_length: 8,
  },
  {
    name: "Papua New Guinea",
    dial_code: "+675",
    code: "PG",
    phone_length: 8,
  },
  {
    name: "Paraguay",
    dial_code: "+595",
    code: "PY",
    phone_length: 9,
  },
  {
    name: "Peru",
    dial_code: "+51",
    code: "PE",
    phone_length: 9,
  },
  {
    name: "Philippines",
    dial_code: "+63",
    code: "PH",
    phone_length: 10,
  },
  {
    name: "Pitcairn",
    dial_code: "+64",
    code: "PN",
    phone_length: 9,
  },
  {
    name: "Poland",
    dial_code: "+48",
    code: "PL",
    phone_length: 9,
  },
  {
    name: "Portugal",
    dial_code: "+351",
    code: "PT",
    phone_length: 9,
  },
  {
    name: "Puerto Rico",
    dial_code: "+1939",
    code: "PR",
    phone_length: 10,
  },
  {
    name: "Qatar",
    dial_code: "+974",
    code: "QA",
    phone_length: 8,
  },
  {
    name: "Romania",
    dial_code: "+40",
    code: "RO",
    phone_length: 10,
  },
  {
    name: "Russia",
    dial_code: "+7",
    code: "RU",
    phone_length: 10,
  },
  {
    name: "Rwanda",
    dial_code: "+250",
    code: "RW",
    phone_length: 9,
  },
  {
    name: "Saint Barthelemy",
    dial_code: "+590",
    code: "BL",
    phone_length: 9,
  },
  {
    name: "Saint Helena, Ascension and Tristan Da Cunha",
    dial_code: "+290",
    code: "SH",
    phone_length: 4,
  },
  {
    name: "Saint Kitts and Nevis",
    dial_code: "+1869",
    code: "KN",
    phone_length: 7,
  },
  {
    name: "Saint Lucia",
    dial_code: "+1758",
    code: "LC",
    phone_length: 7,
  },
  {
    name: "Saint Martin",
    dial_code: "+590",
    code: "MF",
    phone_length: 9,
  },
  {
    name: "Saint Pierre and Miquelon",
    dial_code: "+508",
    code: "PM",
    phone_length: 6,
  },
  {
    name: "Saint Vincent and the Grenadines",
    dial_code: "+1784",
    code: "VC",
    phone_length: 7,
  },
  {
    name: "Samoa",
    dial_code: "+685",
    code: "WS",
    phone_length: 7,
  },
  {
    name: "San Marino",
    dial_code: "+378",
    code: "SM",
    phone_length: 10,
  },
  {
    name: "Sao Tome and Principe",
    dial_code: "+239",
    code: "ST",
    phone_length: 7,
  },
  {
    name: "Saudi Arabia",
    dial_code: "+966",
    code: "SA",
    phone_length: 9,
  },
  {
    name: "Senegal",
    dial_code: "+221",
    code: "SN",
    phone_length: 9,
  },
  {
    name: "Serbia",
    dial_code: "+381",
    code: "RS",
    phone_length: 8,
  },
  {
    name: "Seychelles",
    dial_code: "+248",
    code: "SC",
    phone_length: 7,
  },
  {
    name: "Sierra Leone",
    dial_code: "+232",
    code: "SL",
    phone_length: 8,
  },
  {
    name: "Singapore",
    dial_code: "+65",
    code: "SG",
    phone_length: 8,
  },
  {
    name: "Slovakia",
    dial_code: "+421",
    code: "SK",
    phone_length: 9,
  },
  {
    name: "Slovenia",
    dial_code: "+386",
    code: "SI",
    phone_length: 8,
  },
  {
    name: "Solomon Islands",
    dial_code: "+677",
    code: "SB",
    phone_length: 7,
  },
  {
    name: "Somalia",
    dial_code: "+252",
    code: "SO",
    phone_length: 7,
  },
  {
    name: "South Africa",
    dial_code: "+27",
    code: "ZA",
    phone_length: 9,
  },
  {
    name: "South Sudan",
    dial_code: "+211",
    code: "SS",
    phone_length: 9,
  },
  {
    name: "Spain",
    dial_code: "+34",
    code: "ES",
    phone_length: 9,
  },
  {
    name: "Sri Lanka",
    dial_code: "+94",
    code: "LK",
    phone_length: 9,
  },
  {
    name: "Sudan",
    dial_code: "+249",
    code: "SD",
    phone_length: 9,
  },
  {
    name: "Suriname",
    dial_code: "+597",
    code: "SR",
    phone_length: 7,
  },
  {
    name: "Svalbard and Jan Mayen",
    dial_code: "+47",
    code: "SJ",
    phone_length: 8,
  },
  {
    name: "Swaziland",
    dial_code: "+268",
    code: "SZ",
    phone_length: 7,
  },
  {
    name: "Sweden",
    dial_code: "+46",
    code: "SE",
    phone_length: 9,
  },
  {
    name: "Switzerland",
    dial_code: "+41",
    code: "CH",
    phone_length: 9,
  },
  {
    name: "Syrian Arab Republic",
    dial_code: "+963",
    code: "SY",
    phone_length: 9,
  },
  {
    name: "Taiwan, Province of China",
    dial_code: "+886",
    code: "TW",
    phone_length: 9,
  },
  {
    name: "Tajikistan",
    dial_code: "+992",
    code: "TJ",
    phone_length: 9,
  },
  {
    name: "Tanzania, United Republic of",
    dial_code: "+255",
    code: "TZ",
    phone_length: 9,
  },
  {
    name: "Thailand",
    dial_code: "+66",
    code: "TH",
    phone_length: 9,
  },
  {
    name: "Timor-Leste",
    dial_code: "+670",
    code: "TL",
    phone_length: 7,
  },
  {
    name: "Togo",
    dial_code: "+228",
    code: "TG",
    phone_length: 8,
  },
  {
    name: "Tokelau",
    dial_code: "+690",
    code: "TK",
    phone_length: 4,
  },
  {
    name: "Tonga",
    dial_code: "+676",
    code: "TO",
    phone_length: 5,
  },
  {
    name: "Trinidad and Tobago",
    dial_code: "+1868",
    code: "TT",
    phone_length: 7,
  },
  {
    name: "Tunisia",
    dial_code: "+216",
    code: "TN",
    phone_length: 8,
  },
  {
    name: "Turkey",
    dial_code: "+90",
    code: "TR",
    phone_length: 10,
  },
  {
    name: "Turkmenistan",
    dial_code: "+993",
    code: "TM",
    phone_length: 8,
  },
  {
    name: "Turks and Caicos Islands",
    dial_code: "+1649",
    code: "TC",
    phone_length: 7,
  },
  {
    name: "Tuvalu",
    dial_code: "+688",
    code: "TV",
    phone_length: 5,
  },
  {
    name: "Uganda",
    dial_code: "+256",
    code: "UG",
    phone_length: 9,
  },
  {
    name: "Ukraine",
    dial_code: "+380",
    code: "UA",
    phone_length: 9,
  },
  {
    name: "United Arab Emirates",
    dial_code: "+971",
    code: "AE",
    phone_length: 9,
  },
  {
    name: "United Kingdom",
    dial_code: "+44",
    code: "GB",
    phone_length: 10,
  },
  {
    name: "United States",
    dial_code: "+1",
    code: "US",
    phone_length: 10,
  },
  {
    name: "Uruguay",
    dial_code: "+598",
    code: "UY",
    phone_length: 9,
  },
  {
    name: "Uzbekistan",
    dial_code: "+998",
    code: "UZ",
    phone_length: 9,
  },
  {
    name: "Vanuatu",
    dial_code: "+678",
    code: "VU",
    phone_length: 7,
  },
  {
    name: "Venezuela, Bolivarian Republic of",
    dial_code: "+58",
    code: "VE",
    phone_length: 10,
  },
  {
    name: "Viet Nam",
    dial_code: "+84",
    code: "VN",
    phone_length: 10,
  },
  {
    name: "Virgin Islands, British",
    dial_code: "+1284",
    code: "VG",
    phone_length: 7,
  },
  {
    name: "Virgin Islands, U.S.",
    dial_code: "+1340",
    code: "VI",
    phone_length: 7,
  },
  {
    name: "Wallis and Futuna",
    dial_code: "+681",
    code: "WF",
    phone_length: 6,
  },
  {
    name: "Yemen",
    dial_code: "+967",
    code: "YE",
    phone_length: 9,
  },
  {
    name: "Zambia",
    dial_code: "+260",
    code: "ZM",
    phone_length: 9,
  },
  {
    name: "Zimbabwe",
    dial_code: "+263",
    code: "ZW",
    phone_length: 9,
  },
];

export const CurrenciesList = [
  {
    name: "US Dollar",
    symbol: "$",
    symbolNative: "$",
    decimalDigits: 2,
    rounding: 0,
    code: "USD",
    namePlural: "US dollars",
  },
  {
    name: "Canadian Dollar",
    symbol: "CA$",
    symbolNative: "$",
    decimalDigits: 2,
    rounding: 0,
    code: "CAD",
    namePlural: "Canadian dollars",
  },
  {
    name: "Euro",
    symbol: "€",
    symbolNative: "€",
    decimalDigits: 2,
    rounding: 0,
    code: "EUR",
    namePlural: "euros",
  },
  {
    name: "United Arab Emirates Dirham",
    symbol: "AED",
    symbolNative: "د.إ.‏",
    decimalDigits: 2,
    rounding: 0,
    code: "AED",
    namePlural: "UAE dirhams",
  },
  {
    name: "Afghan Afghani",
    symbol: "Af",
    symbolNative: "؋",
    decimalDigits: 0,
    rounding: 0,
    code: "AFN",
    namePlural: "Afghan Afghanis",
  },
  {
    name: "Albanian Lek",
    symbol: "ALL",
    symbolNative: "Lek",
    decimalDigits: 0,
    rounding: 0,
    code: "ALL",
    namePlural: "Albanian lekë",
  },
  {
    name: "Armenian Dram",
    symbol: "AMD",
    symbolNative: "դր.",
    decimalDigits: 0,
    rounding: 0,
    code: "AMD",
    namePlural: "Armenian drams",
  },
  {
    name: "Argentine Peso",
    symbol: "AR$",
    symbolNative: "$",
    decimalDigits: 2,
    rounding: 0,
    code: "ARS",
    namePlural: "Argentine pesos",
  },
  {
    name: "Australian Dollar",
    symbol: "AU$",
    symbolNative: "$",
    decimalDigits: 2,
    rounding: 0,
    code: "AUD",
    namePlural: "Australian dollars",
  },
  {
    name: "Azerbaijani Manat",
    symbol: "man.",
    symbolNative: "ман.",
    decimalDigits: 2,
    rounding: 0,
    code: "AZN",
    namePlural: "Azerbaijani manats",
  },
  {
    name: "Bosnia-Herzegovina Convertible Mark",
    symbol: "KM",
    symbolNative: "KM",
    decimalDigits: 2,
    rounding: 0,
    code: "BAM",
    namePlural: "Bosnia-Herzegovina convertible marks",
  },
  {
    name: "Bangladeshi Taka",
    symbol: "Tk",
    symbolNative: "৳",
    decimalDigits: 2,
    rounding: 0,
    code: "BDT",
    namePlural: "Bangladeshi takas",
  },
  {
    name: "Bulgarian Lev",
    symbol: "BGN",
    symbolNative: "лв.",
    decimalDigits: 2,
    rounding: 0,
    code: "BGN",
    namePlural: "Bulgarian leva",
  },
  {
    name: "Bahraini Dinar",
    symbol: "BD",
    symbolNative: "د.ب.‏",
    decimalDigits: 3,
    rounding: 0,
    code: "BHD",
    namePlural: "Bahraini dinars",
  },
  {
    name: "Burundian Franc",
    symbol: "FBu",
    symbolNative: "FBu",
    decimalDigits: 0,
    rounding: 0,
    code: "BIF",
    namePlural: "Burundian francs",
  },
  {
    name: "Brunei Dollar",
    symbol: "BN$",
    symbolNative: "$",
    decimalDigits: 2,
    rounding: 0,
    code: "BND",
    namePlural: "Brunei dollars",
  },
  {
    name: "Bolivian Boliviano",
    symbol: "Bs",
    symbolNative: "Bs",
    decimalDigits: 2,
    rounding: 0,
    code: "BOB",
    namePlural: "Bolivian bolivianos",
  },
  {
    name: "Brazilian Real",
    symbol: "R$",
    symbolNative: "R$",
    decimalDigits: 2,
    rounding: 0,
    code: "BRL",
    namePlural: "Brazilian reals",
  },
  {
    name: "Botswanan Pula",
    symbol: "BWP",
    symbolNative: "P",
    decimalDigits: 2,
    rounding: 0,
    code: "BWP",
    namePlural: "Botswanan pulas",
  },
  {
    name: "Belarusian Ruble",
    symbol: "Br",
    symbolNative: "руб.",
    decimalDigits: 2,
    rounding: 0,
    code: "BYN",
    namePlural: "Belarusian rubles",
  },
  {
    name: "Belize Dollar",
    symbol: "BZ$",
    symbolNative: "$",
    decimalDigits: 2,
    rounding: 0,
    code: "BZD",
    namePlural: "Belize dollars",
  },
  {
    name: "Congolese Franc",
    symbol: "CDF",
    symbolNative: "FrCD",
    decimalDigits: 2,
    rounding: 0,
    code: "CDF",
    namePlural: "Congolese francs",
  },
  {
    name: "Swiss Franc",
    symbol: "CHF",
    symbolNative: "CHF",
    decimalDigits: 2,
    rounding: 0.05,
    code: "CHF",
    namePlural: "Swiss francs",
  },
  {
    name: "Chilean Peso",
    symbol: "CL$",
    symbolNative: "$",
    decimalDigits: 0,
    rounding: 0,
    code: "CLP",
    namePlural: "Chilean pesos",
  },
  {
    name: "Chinese Yuan",
    symbol: "CN¥",
    symbolNative: "CN¥",
    decimalDigits: 2,
    rounding: 0,
    code: "CNY",
    namePlural: "Chinese yuan",
  },
  {
    name: "Colombian Peso",
    symbol: "CO$",
    symbolNative: "$",
    decimalDigits: 0,
    rounding: 0,
    code: "COP",
    namePlural: "Colombian pesos",
  },
  {
    name: "Costa Rican Colón",
    symbol: "₡",
    symbolNative: "₡",
    decimalDigits: 0,
    rounding: 0,
    code: "CRC",
    namePlural: "Costa Rican colóns",
  },
  {
    name: "Cape Verdean Escudo",
    symbol: "CV$",
    symbolNative: "CV$",
    decimalDigits: 2,
    rounding: 0,
    code: "CVE",
    namePlural: "Cape Verdean escudos",
  },
  {
    name: "Czech Republic Koruna",
    symbol: "Kč",
    symbolNative: "Kč",
    decimalDigits: 2,
    rounding: 0,
    code: "CZK",
    namePlural: "Czech Republic korunas",
  },
  {
    name: "Djiboutian Franc",
    symbol: "Fdj",
    symbolNative: "Fdj",
    decimalDigits: 0,
    rounding: 0,
    code: "DJF",
    namePlural: "Djiboutian francs",
  },
  {
    name: "Danish Krone",
    symbol: "Dkr",
    symbolNative: "kr",
    decimalDigits: 2,
    rounding: 0,
    code: "DKK",
    namePlural: "Danish kroner",
  },
  {
    name: "Dominican Peso",
    symbol: "RD$",
    symbolNative: "RD$",
    decimalDigits: 2,
    rounding: 0,
    code: "DOP",
    namePlural: "Dominican pesos",
  },
  {
    name: "Algerian Dinar",
    symbol: "DA",
    symbolNative: "د.ج.‏",
    decimalDigits: 2,
    rounding: 0,
    code: "DZD",
    namePlural: "Algerian dinars",
  },
  {
    name: "Estonian Kroon",
    symbol: "Ekr",
    symbolNative: "kr",
    decimalDigits: 2,
    rounding: 0,
    code: "EEK",
    namePlural: "Estonian kroons",
  },
  {
    name: "Egyptian Pound",
    symbol: "EGP",
    symbolNative: "ج.م.‏",
    decimalDigits: 2,
    rounding: 0,
    code: "EGP",
    namePlural: "Egyptian pounds",
  },
  {
    name: "Eritrean Nakfa",
    symbol: "Nfk",
    symbolNative: "Nfk",
    decimalDigits: 2,
    rounding: 0,
    code: "ERN",
    namePlural: "Eritrean nakfas",
  },
  {
    name: "Ethiopian Birr",
    symbol: "Br",
    symbolNative: "Br",
    decimalDigits: 2,
    rounding: 0,
    code: "ETB",
    namePlural: "Ethiopian birrs",
  },
  {
    name: "British Pound Sterling",
    symbol: "£",
    symbolNative: "£",
    decimalDigits: 2,
    rounding: 0,
    code: "GBP",
    namePlural: "British pounds sterling",
  },
  {
    name: "Georgian Lari",
    symbol: "GEL",
    symbolNative: "GEL",
    decimalDigits: 2,
    rounding: 0,
    code: "GEL",
    namePlural: "Georgian laris",
  },
  {
    name: "Ghanaian Cedi",
    symbol: "GH₵",
    symbolNative: "GH₵",
    decimalDigits: 2,
    rounding: 0,
    code: "GHS",
    namePlural: "Ghanaian cedis",
  },
  {
    name: "Guinean Franc",
    symbol: "FG",
    symbolNative: "FG",
    decimalDigits: 0,
    rounding: 0,
    code: "GNF",
    namePlural: "Guinean francs",
  },
  {
    name: "Guatemalan Quetzal",
    symbol: "GTQ",
    symbolNative: "Q",
    decimalDigits: 2,
    rounding: 0,
    code: "GTQ",
    namePlural: "Guatemalan quetzals",
  },
  {
    name: "Hong Kong Dollar",
    symbol: "HK$",
    symbolNative: "$",
    decimalDigits: 2,
    rounding: 0,
    code: "HKD",
    namePlural: "Hong Kong dollars",
  },
  {
    name: "Honduran Lempira",
    symbol: "HNL",
    symbolNative: "L",
    decimalDigits: 2,
    rounding: 0,
    code: "HNL",
    namePlural: "Honduran lempiras",
  },
  {
    name: "Croatian Kuna",
    symbol: "kn",
    symbolNative: "kn",
    decimalDigits: 2,
    rounding: 0,
    code: "HRK",
    namePlural: "Croatian kunas",
  },
  {
    name: "Hungarian Forint",
    symbol: "Ft",
    symbolNative: "Ft",
    decimalDigits: 0,
    rounding: 0,
    code: "HUF",
    namePlural: "Hungarian forints",
  },
  {
    name: "Indonesian Rupiah",
    symbol: "Rp",
    symbolNative: "Rp",
    decimalDigits: 0,
    rounding: 0,
    code: "IDR",
    namePlural: "Indonesian rupiahs",
  },
  {
    name: "Israeli New Sheqel",
    symbol: "₪",
    symbolNative: "₪",
    decimalDigits: 2,
    rounding: 0,
    code: "ILS",
    namePlural: "Israeli new sheqels",
  },
  {
    name: "Indian Rupee",
    symbol: "Rs",
    symbolNative: "টকা",
    decimalDigits: 2,
    rounding: 0,
    code: "INR",
    namePlural: "Indian rupees",
  },
  {
    name: "Iraqi Dinar",
    symbol: "IQD",
    symbolNative: "د.ع.‏",
    decimalDigits: 0,
    rounding: 0,
    code: "IQD",
    namePlural: "Iraqi dinars",
  },
  {
    name: "Iranian Rial",
    symbol: "IRR",
    symbolNative: "﷼",
    decimalDigits: 0,
    rounding: 0,
    code: "IRR",
    namePlural: "Iranian rials",
  },
  {
    name: "Icelandic Króna",
    symbol: "Ikr",
    symbolNative: "kr",
    decimalDigits: 0,
    rounding: 0,
    code: "ISK",
    namePlural: "Icelandic krónur",
  },
  {
    name: "Jamaican Dollar",
    symbol: "J$",
    symbolNative: "$",
    decimalDigits: 2,
    rounding: 0,
    code: "JMD",
    namePlural: "Jamaican dollars",
  },
  {
    name: "Jordanian Dinar",
    symbol: "JD",
    symbolNative: "د.أ.‏",
    decimalDigits: 3,
    rounding: 0,
    code: "JOD",
    namePlural: "Jordanian dinars",
  },
  {
    name: "Japanese Yen",
    symbol: "¥",
    symbolNative: "￥",
    decimalDigits: 0,
    rounding: 0,
    code: "JPY",
    namePlural: "Japanese yen",
  },
  {
    name: "Kenyan Shilling",
    symbol: "Ksh",
    symbolNative: "Ksh",
    decimalDigits: 2,
    rounding: 0,
    code: "KES",
    namePlural: "Kenyan shillings",
  },
  {
    name: "Cambodian Riel",
    symbol: "KHR",
    symbolNative: "៛",
    decimalDigits: 2,
    rounding: 0,
    code: "KHR",
    namePlural: "Cambodian riels",
  },
  {
    name: "Comorian Franc",
    symbol: "CF",
    symbolNative: "FC",
    decimalDigits: 0,
    rounding: 0,
    code: "KMF",
    namePlural: "Comorian francs",
  },
  {
    name: "South Korean Won",
    symbol: "₩",
    symbolNative: "₩",
    decimalDigits: 0,
    rounding: 0,
    code: "KRW",
    namePlural: "South Korean won",
  },
  {
    name: "Kuwaiti Dinar",
    symbol: "KD",
    symbolNative: "د.ك.‏",
    decimalDigits: 3,
    rounding: 0,
    code: "KWD",
    namePlural: "Kuwaiti dinars",
  },
  {
    name: "Kazakhstani Tenge",
    symbol: "KZT",
    symbolNative: "тңг.",
    decimalDigits: 2,
    rounding: 0,
    code: "KZT",
    namePlural: "Kazakhstani tenges",
  },
  {
    name: "Lebanese Pound",
    symbol: "LB£",
    symbolNative: "ل.ل.‏",
    decimalDigits: 0,
    rounding: 0,
    code: "LBP",
    namePlural: "Lebanese pounds",
  },
  {
    name: "Sri Lankan Rupee",
    symbol: "SLRs",
    symbolNative: "SL Re",
    decimalDigits: 2,
    rounding: 0,
    code: "LKR",
    namePlural: "Sri Lankan rupees",
  },
  {
    name: "Lithuanian Litas",
    symbol: "Lt",
    symbolNative: "Lt",
    decimalDigits: 2,
    rounding: 0,
    code: "LTL",
    namePlural: "Lithuanian litai",
  },
  {
    name: "Latvian Lats",
    symbol: "Ls",
    symbolNative: "Ls",
    decimalDigits: 2,
    rounding: 0,
    code: "LVL",
    namePlural: "Latvian lati",
  },
  {
    name: "Libyan Dinar",
    symbol: "LD",
    symbolNative: "د.ل.‏",
    decimalDigits: 3,
    rounding: 0,
    code: "LYD",
    namePlural: "Libyan dinars",
  },
  {
    name: "Moroccan Dirham",
    symbol: "MAD",
    symbolNative: "د.م.‏",
    decimalDigits: 2,
    rounding: 0,
    code: "MAD",
    namePlural: "Moroccan dirhams",
  },
  {
    name: "Moldovan Leu",
    symbol: "MDL",
    symbolNative: "MDL",
    decimalDigits: 2,
    rounding: 0,
    code: "MDL",
    namePlural: "Moldovan lei",
  },
  {
    name: "Malagasy Ariary",
    symbol: "MGA",
    symbolNative: "MGA",
    decimalDigits: 0,
    rounding: 0,
    code: "MGA",
    namePlural: "Malagasy Ariaries",
  },
  {
    name: "Macedonian Denar",
    symbol: "MKD",
    symbolNative: "MKD",
    decimalDigits: 2,
    rounding: 0,
    code: "MKD",
    namePlural: "Macedonian denari",
  },
  {
    name: "Myanma Kyat",
    symbol: "MMK",
    symbolNative: "K",
    decimalDigits: 0,
    rounding: 0,
    code: "MMK",
    namePlural: "Myanma kyats",
  },
  {
    name: "Macanese Pataca",
    symbol: "MOP$",
    symbolNative: "MOP$",
    decimalDigits: 2,
    rounding: 0,
    code: "MOP",
    namePlural: "Macanese patacas",
  },
  {
    name: "Mauritian Rupee",
    symbol: "MURs",
    symbolNative: "MURs",
    decimalDigits: 0,
    rounding: 0,
    code: "MUR",
    namePlural: "Mauritian rupees",
  },
  {
    name: "Mexican Peso",
    symbol: "MX$",
    symbolNative: "$",
    decimalDigits: 2,
    rounding: 0,
    code: "MXN",
    namePlural: "Mexican pesos",
  },
  {
    name: "Malaysian Ringgit",
    symbol: "RM",
    symbolNative: "RM",
    decimalDigits: 2,
    rounding: 0,
    code: "MYR",
    namePlural: "Malaysian ringgits",
  },
  {
    name: "Mozambican Metical",
    symbol: "MTn",
    symbolNative: "MTn",
    decimalDigits: 2,
    rounding: 0,
    code: "MZN",
    namePlural: "Mozambican meticals",
  },
  {
    name: "Namibian Dollar",
    symbol: "N$",
    symbolNative: "N$",
    decimalDigits: 2,
    rounding: 0,
    code: "NAD",
    namePlural: "Namibian dollars",
  },
  {
    name: "Nigerian Naira",
    symbol: "₦",
    symbolNative: "₦",
    decimalDigits: 2,
    rounding: 0,
    code: "NGN",
    namePlural: "Nigerian nairas",
  },
  {
    name: "Nicaraguan Córdoba",
    symbol: "C$",
    symbolNative: "C$",
    decimalDigits: 2,
    rounding: 0,
    code: "NIO",
    namePlural: "Nicaraguan córdobas",
  },
  {
    name: "Norwegian Krone",
    symbol: "Nkr",
    symbolNative: "kr",
    decimalDigits: 2,
    rounding: 0,
    code: "NOK",
    namePlural: "Norwegian kroner",
  },
  {
    name: "Nepalese Rupee",
    symbol: "NPRs",
    symbolNative: "नेरू",
    decimalDigits: 2,
    rounding: 0,
    code: "NPR",
    namePlural: "Nepalese rupees",
  },
  {
    name: "New Zealand Dollar",
    symbol: "NZ$",
    symbolNative: "$",
    decimalDigits: 2,
    rounding: 0,
    code: "NZD",
    namePlural: "New Zealand dollars",
  },
  {
    name: "Omani Rial",
    symbol: "OMR",
    symbolNative: "ر.ع.‏",
    decimalDigits: 3,
    rounding: 0,
    code: "OMR",
    namePlural: "Omani rials",
  },
  {
    name: "Panamanian Balboa",
    symbol: "B/.",
    symbolNative: "B/.",
    decimalDigits: 2,
    rounding: 0,
    code: "PAB",
    namePlural: "Panamanian balboas",
  },
  {
    name: "Peruvian Nuevo Sol",
    symbol: "S/.",
    symbolNative: "S/.",
    decimalDigits: 2,
    rounding: 0,
    code: "PEN",
    namePlural: "Peruvian nuevos soles",
  },
  {
    name: "Philippine Peso",
    symbol: "₱",
    symbolNative: "₱",
    decimalDigits: 2,
    rounding: 0,
    code: "PHP",
    namePlural: "Philippine pesos",
  },
  {
    name: "Pakistani Rupee",
    symbol: "PKRs",
    symbolNative: "₨",
    decimalDigits: 0,
    rounding: 0,
    code: "PKR",
    namePlural: "Pakistani rupees",
  },
  {
    name: "Polish Zloty",
    symbol: "zł",
    symbolNative: "zł",
    decimalDigits: 2,
    rounding: 0,
    code: "PLN",
    namePlural: "Polish zlotys",
  },
  {
    name: "Paraguayan Guarani",
    symbol: "₲",
    symbolNative: "₲",
    decimalDigits: 0,
    rounding: 0,
    code: "PYG",
    namePlural: "Paraguayan guaranis",
  },
  {
    name: "Qatari Rial",
    symbol: "QR",
    symbolNative: "ر.ق.‏",
    decimalDigits: 2,
    rounding: 0,
    code: "QAR",
    namePlural: "Qatari rials",
  },
  {
    name: "Romanian Leu",
    symbol: "RON",
    symbolNative: "RON",
    decimalDigits: 2,
    rounding: 0,
    code: "RON",
    namePlural: "Romanian lei",
  },
  {
    name: "Serbian Dinar",
    symbol: "din.",
    symbolNative: "дин.",
    decimalDigits: 0,
    rounding: 0,
    code: "RSD",
    namePlural: "Serbian dinars",
  },
  {
    name: "Russian Ruble",
    symbol: "RUB",
    symbolNative: "₽.",
    decimalDigits: 2,
    rounding: 0,
    code: "RUB",
    namePlural: "Russian rubles",
  },
  {
    name: "Rwandan Franc",
    symbol: "RWF",
    symbolNative: "FR",
    decimalDigits: 0,
    rounding: 0,
    code: "RWF",
    namePlural: "Rwandan francs",
  },
  {
    name: "Saudi Riyal",
    symbol: "SR",
    symbolNative: "ر.س.‏",
    decimalDigits: 2,
    rounding: 0,
    code: "SAR",
    namePlural: "Saudi riyals",
  },
  {
    name: "Sudanese Pound",
    symbol: "SDG",
    symbolNative: "SDG",
    decimalDigits: 2,
    rounding: 0,
    code: "SDG",
    namePlural: "Sudanese pounds",
  },
  {
    name: "Swedish Krona",
    symbol: "Skr",
    symbolNative: "kr",
    decimalDigits: 2,
    rounding: 0,
    code: "SEK",
    namePlural: "Swedish kronor",
  },
  {
    name: "Singapore Dollar",
    symbol: "S$",
    symbolNative: "$",
    decimalDigits: 2,
    rounding: 0,
    code: "SGD",
    namePlural: "Singapore dollars",
  },
  {
    name: "Somali Shilling",
    symbol: "Ssh",
    symbolNative: "Ssh",
    decimalDigits: 0,
    rounding: 0,
    code: "SOS",
    namePlural: "Somali shillings",
  },
  {
    name: "Syrian Pound",
    symbol: "SY£",
    symbolNative: "ل.س.‏",
    decimalDigits: 0,
    rounding: 0,
    code: "SYP",
    namePlural: "Syrian pounds",
  },
  {
    name: "Thai Baht",
    symbol: "฿",
    symbolNative: "฿",
    decimalDigits: 2,
    rounding: 0,
    code: "THB",
    namePlural: "Thai baht",
  },
  {
    name: "Tunisian Dinar",
    symbol: "DT",
    symbolNative: "د.ت.‏",
    decimalDigits: 3,
    rounding: 0,
    code: "TND",
    namePlural: "Tunisian dinars",
  },
  {
    name: "Tongan Paʻanga",
    symbol: "T$",
    symbolNative: "T$",
    decimalDigits: 2,
    rounding: 0,
    code: "TOP",
    namePlural: "Tongan paʻanga",
  },
  {
    name: "Turkish Lira",
    symbol: "TL",
    symbolNative: "TL",
    decimalDigits: 2,
    rounding: 0,
    code: "TRY",
    namePlural: "Turkish Lira",
  },
  {
    name: "Trinidad and Tobago Dollar",
    symbol: "TT$",
    symbolNative: "$",
    decimalDigits: 2,
    rounding: 0,
    code: "TTD",
    namePlural: "Trinidad and Tobago dollars",
  },
  {
    name: "New Taiwan Dollar",
    symbol: "NT$",
    symbolNative: "NT$",
    decimalDigits: 2,
    rounding: 0,
    code: "TWD",
    namePlural: "New Taiwan dollars",
  },
  {
    name: "Tanzanian Shilling",
    symbol: "TSh",
    symbolNative: "TSh",
    decimalDigits: 0,
    rounding: 0,
    code: "TZS",
    namePlural: "Tanzanian shillings",
  },
  {
    name: "Ukrainian Hryvnia",
    symbol: "₴",
    symbolNative: "₴",
    decimalDigits: 2,
    rounding: 0,
    code: "UAH",
    namePlural: "Ukrainian hryvnias",
  },
  {
    name: "Ugandan Shilling",
    symbol: "USh",
    symbolNative: "USh",
    decimalDigits: 0,
    rounding: 0,
    code: "UGX",
    namePlural: "Ugandan shillings",
  },
  {
    name: "Uruguayan Peso",
    symbol: "$U",
    symbolNative: "$",
    decimalDigits: 2,
    rounding: 0,
    code: "UYU",
    namePlural: "Uruguayan pesos",
  },
  {
    name: "Uzbekistan Som",
    symbol: "UZS",
    symbolNative: "UZS",
    decimalDigits: 0,
    rounding: 0,
    code: "UZS",
    namePlural: "Uzbekistan som",
  },
  {
    name: "Venezuelan Bolívar",
    symbol: "Bs.F.",
    symbolNative: "Bs.F.",
    decimalDigits: 2,
    rounding: 0,
    code: "VEF",
    namePlural: "Venezuelan bolívars",
  },
  {
    name: "Vietnamese Dong",
    symbol: "₫",
    symbolNative: "₫",
    decimalDigits: 0,
    rounding: 0,
    code: "VND",
    namePlural: "Vietnamese dong",
  },
  {
    name: "CFA Franc BEAC",
    symbol: "FCFA",
    symbolNative: "FCFA",
    decimalDigits: 0,
    rounding: 0,
    code: "XAF",
    namePlural: "CFA francs BEAC",
  },
  {
    name: "CFA Franc BCEAO",
    symbol: "CFA",
    symbolNative: "CFA",
    decimalDigits: 0,
    rounding: 0,
    code: "XOF",
    namePlural: "CFA francs BCEAO",
  },
  {
    name: "Yemeni Rial",
    symbol: "YR",
    symbolNative: "ر.ي.‏",
    decimalDigits: 0,
    rounding: 0,
    code: "YER",
    namePlural: "Yemeni rials",
  },
  {
    name: "South African Rand",
    symbol: "R",
    symbolNative: "R",
    decimalDigits: 2,
    rounding: 0,
    code: "ZAR",
    namePlural: "South African rand",
  },
  {
    name: "Zambian Kwacha",
    symbol: "ZK",
    symbolNative: "ZK",
    decimalDigits: 0,
    rounding: 0,
    code: "ZMK",
    namePlural: "Zambian kwachas",
  },
  {
    name: "Zimbabwean Dollar",
    symbol: "ZWL$",
    symbolNative: "ZWL$",
    decimalDigits: 0,
    rounding: 0,
    code: "ZWL",
    namePlural: "Zimbabwean Dollar",
  },
];
